var App = App || {};

App.WidgetPerks = (function ($) {
    'use strict';

    function Init(widget) {
        const animate = widget.find(".widget-perks__badges");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".partial-badge:nth-child(1)", type: "animate__fadeInLeft", stagger: 0 },
                { selector: ".partial-badge:nth-child(2)", type: "animate__fadeInRight", stagger: 0 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);